import List from '@mui/material/List';
import SidebarSectionWrapper from './SidebarSectionWrapper';
import SidebarSectionTitle from './SidebarSectionTitle';
import NavigationItem from './NavigationItem';
import { pagesText } from '../../../constants/pagesText';
import SidebarDivider from '../../../components/SidebarDivider';

const sidebarNavigationList = [
  {
    title: pagesText.downloadsNavigation.serverAgent,
    icon: 'basil:file-download-outline',
    path: '/content/downloads/AppControl%20Server%20Agent_X86.zip',
  },
  {
    title: pagesText.downloadsNavigation.clientAgent,
    icon: 'basil:file-download-outline',
    path: '/content/downloads/WDACLogCollectorCore.zip',
  },
];

const DownloadsSidebar = () => (
  <>
    <SidebarSectionWrapper>
      <SidebarSectionTitle>Downloads</SidebarSectionTitle>
      <List
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
        }}>
        {sidebarNavigationList.map(({ icon, title, path }) => (
          <NavigationItem
            download
            key={title}
            icon={icon}
            title={title}
            path={path}
            externalLink={true}
          />
        ))}
      </List>
    </SidebarSectionWrapper>
    <SidebarDivider />
  </>
);

export default DownloadsSidebar;
